'use client';

import { type JWTToken, useCustomer } from '@/hooks/use-customer';
import { ga4_infoPage } from '@/libs/ga4/actions/info-page';
import { usePathname } from '@/navigation';
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { isJWT } from 'validator';

export function RouteChangeListener() {
  const pathname = usePathname();
  const { token, customerType } = useCustomer();

  useEffect(() => {
    if (!token || !isJWT(token)) {
      ga4_infoPage({
        user: { status: 'not logged in', id: '', type: 'new' },
        content_group: pathname.includes('basket') ? 'Checkout page' : '',
      });
    } else {
      const {
        data: { user_id },
      } = jwtDecode<JWTToken>(token);
      ga4_infoPage({
        user: { status: 'logged in', id: user_id, type: customerType },
        content_group: pathname.includes('basket') ? 'Checkout page' : '',
      });
    }
  }, [pathname]);

  return <></>;
}
